import { render } from "./AdminDashboard.vue?vue&type=template&id=abb7d214"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/admin/AdminDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "abb7d214"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('abb7d214', __exports__)) {
    api.reload('abb7d214', __exports__)
  }
  
  module.hot.accept("./AdminDashboard.vue?vue&type=template&id=abb7d214", () => {
    api.rerender('abb7d214', render)
  })

}


export default __exports__